export default {
  BASE_PATH,
  API_ROOT: '/legacy/api',
  LANGUAGE: 'en'
};
